/**
 * Channels Module Constants
 */

import { ChannelName } from '../types';

// Channel display info
export const CHANNEL_INFO: Record<ChannelName, { displayName: string; displayNameAr: string; bgColor: string }> = {
  airbnb: {
    displayName: 'Airbnb',
    displayNameAr: 'Airbnb',
    bgColor: '#FF5A5F',
  },
  booking: {
    displayName: 'Booking.com',
    displayNameAr: 'Booking.com',
    bgColor: '#003580',
  },
  gathern: {
    displayName: 'Gathern',
    displayNameAr: 'قاذرن',
    bgColor: '#F5A623',
  },
};

// Connection steps
export const CONNECTION_STEPS = {
  CONNECT: 'connect',
  SUCCESS: 'success',
  IMPORT: 'import',
  PROGRESS: 'progress',
} as const;

// Translation keys
export const T_KEYS = {
  // Page
  PAGE_TITLE: 'CHANNELS.PAGE_TITLE',
  PAGE_DESCRIPTION: 'CHANNELS.PAGE_DESCRIPTION',
  
  // Banner
  CONNECT_FIRST_CHANNEL: 'CHANNELS.CONNECT_FIRST_CHANNEL',
  CONNECT_FIRST_CHANNEL_DESC: 'CHANNELS.CONNECT_FIRST_CHANNEL_DESC',
  CONNECT_NOW: 'CHANNELS.CONNECT_NOW',
  
  // Status
  CONNECTED: 'CHANNELS.CONNECTED',
  NOT_CONNECTED: 'CHANNELS.NOT_CONNECTED',
  CONNECTING: 'CHANNELS.CONNECTING',
  
  // Card
  CONNECTED_ACCOUNTS: 'CHANNELS.CONNECTED_ACCOUNTS',
  DISCONNECTED_ACCOUNTS: 'CHANNELS.DISCONNECTED_ACCOUNTS',
  IMPORTED_UNITS: 'CHANNELS.IMPORTED_UNITS',
  CONNECT_WITH: 'CHANNELS.CONNECT_WITH',
  MANAGE_ACCOUNTS: 'CHANNELS.MANAGE_ACCOUNTS',
  
  // Connect Step
  CONNECT_ACCOUNT: 'CHANNELS.CONNECT_ACCOUNT',
  CONNECT_DESCRIPTION: 'CHANNELS.CONNECT_DESCRIPTION',
  OFFICIAL_PARTNER: 'CHANNELS.OFFICIAL_PARTNER',
  LOGIN_PROMPT: 'CHANNELS.LOGIN_PROMPT',
  TERMS_AGREEMENT: 'CHANNELS.TERMS_AGREEMENT',
  TERMS_OF_SERVICE: 'CHANNELS.TERMS_OF_SERVICE',
  PRIVACY_POLICY: 'CHANNELS.PRIVACY_POLICY',
  CONNECT: 'CHANNELS.CONNECT',
  CANCEL: 'CHANNELS.CANCEL',
  I_AGREE_TO: 'CHANNELS.I_AGREE_TO',
  AND: 'CHANNELS.AND',
  OF_MSOOL: 'CHANNELS.OF_MSOOL',
  CONNECTING_LOADING: 'CHANNELS.CONNECTING_LOADING',
  
  // Connect Channel View
  CONNECT_BOOKING_ACCOUNT: 'CHANNELS.CONNECT_BOOKING_ACCOUNT',
  CONNECT_CHANNEL_ACCOUNT: 'CHANNELS.CONNECT_CHANNEL_ACCOUNT',
  CONNECT_DESCRIPTION_BOOKING: 'CHANNELS.CONNECT_DESCRIPTION_BOOKING',
  CONNECT_DESCRIPTION_DEFAULT: 'CHANNELS.CONNECT_DESCRIPTION_DEFAULT',
  FAILED_GET_CONNECTION_LINK: 'CHANNELS.FAILED_GET_CONNECTION_LINK',
  SOME_PROPERTY_IDS_INVALID: 'CHANNELS.SOME_PROPERTY_IDS_INVALID',
  VALIDATION_SUCCESSFUL: 'CHANNELS.VALIDATION_SUCCESSFUL',
  
  // Connect Step Descriptions
  AIRBNB_CONNECT_DESC: 'CHANNELS.AIRBNB_CONNECT_DESC',
  BOOKING_CONNECT_DESC: 'CHANNELS.BOOKING_CONNECT_DESC',
  GATHERN_CONNECT_DESC: 'CHANNELS.GATHERN_CONNECT_DESC',
  
  // Success Step
  CONNECTION_SUCCESS: 'CHANNELS.CONNECTION_SUCCESS',
  CONNECTION_SUCCESS_DESC: 'CHANNELS.CONNECTION_SUCCESS_DESC',
  IMPORT_NOW: 'CHANNELS.IMPORT_NOW',
  IMPORT_LATER: 'CHANNELS.IMPORT_LATER',
  IMPORT_SUCCESS: 'CHANNELS.IMPORT_SUCCESS',
  
  // Import Step
  FOUND_UNITS: 'CHANNELS.FOUND_UNITS',
  FOUND_UNITS_DESC: 'CHANNELS.FOUND_UNITS_DESC',
  SELECT_UNITS_DESC: 'CHANNELS.SELECT_UNITS_DESC',
  UNITS_COUNT: 'CHANNELS.UNITS_COUNT',
  UNITS_COUNT_LABEL: 'CHANNELS.UNITS_COUNT_LABEL',
  CHANNEL_UNITS: 'CHANNELS.CHANNEL_UNITS',
  SEARCH_PROPERTIES: 'CHANNELS.SEARCH_PROPERTIES',
  START_IMPORT: 'CHANNELS.START_IMPORT',
  NOT_IMPORTED: 'CHANNELS.NOT_IMPORTED',
  IMPORTED: 'CHANNELS.IMPORTED',
  PROPERTY_ID: 'CHANNELS.PROPERTY_ID',
  TABLE_PROPERTY: 'CHANNELS.TABLE_PROPERTY',
  TABLE_ADDRESS: 'CHANNELS.TABLE_ADDRESS',
  TABLE_ID: 'CHANNELS.TABLE_ID',
  TABLE_STATUS: 'CHANNELS.TABLE_STATUS',
  IMPORTING: 'CHANNELS.IMPORTING',
  IMPORTING_LOADING: 'CHANNELS.IMPORTING_LOADING',
  NO_UNITS_AVAILABLE: 'CHANNELS.NO_UNITS_AVAILABLE',
  NO_UNITS_AVAILABLE_DESC: 'CHANNELS.NO_UNITS_AVAILABLE_DESC',
  
  // Progress Step
  IMPORT_IN_PROGRESS: 'CHANNELS.IMPORT_IN_PROGRESS',
  IMPORT_PROGRESS_DESC: 'CHANNELS.IMPORT_PROGRESS_DESC',
  GO_TO_DASHBOARD: 'CHANNELS.GO_TO_DASHBOARD',
  STAY_HERE: 'CHANNELS.STAY_HERE',
  WILL_NOTIFY: 'CHANNELS.WILL_NOTIFY',
  
  // Manage Channel Page
  CHANNEL_ACCOUNTS: 'CHANNELS.CHANNEL_ACCOUNTS',
  MANAGE_CHANNEL_DESCRIPTION: 'CHANNELS.MANAGE_CHANNEL_DESCRIPTION',
  ADD_NEW_ACCOUNT: 'CHANNELS.ADD_NEW_ACCOUNT',
  BACK: 'CHANNELS.BACK',
  ACCOUNT: 'CHANNELS.ACCOUNT',
  DISCONNECTED: 'CHANNELS.DISCONNECTED',
  LAST_SYNC_NOW: 'CHANNELS.LAST_SYNC_NOW',
  LAST_SYNC_MINUTES: 'CHANNELS.LAST_SYNC_MINUTES',
  LAST_SYNC_HOURS: 'CHANNELS.LAST_SYNC_HOURS',
  LAST_SYNC_DAYS: 'CHANNELS.LAST_SYNC_DAYS',
  IMPORT_NEW_UNITS: 'CHANNELS.IMPORT_NEW_UNITS',
  REFRESH_SYNC: 'CHANNELS.REFRESH_SYNC',
  SETTINGS: 'CHANNELS.SETTINGS',
  IMPORTED_UNITS_TITLE: 'CHANNELS.IMPORTED_UNITS_TITLE',
  UNITS: 'CHANNELS.UNITS',
  ALL_STATUSES: 'CHANNELS.ALL_STATUSES',
  STATUS_SYNCED: 'CHANNELS.STATUS_SYNCED',
  STATUS_NOT_SYNCED: 'CHANNELS.STATUS_NOT_SYNCED',
  STATUS_FAILED: 'CHANNELS.STATUS_FAILED',
  STATUS_DISCONNECTED: 'CHANNELS.STATUS_DISCONNECTED',
  SEARCH_PLACEHOLDER: 'CHANNELS.SEARCH_PLACEHOLDER',
  PROPERTY: 'CHANNELS.PROPERTY',
  ADDRESS: 'CHANNELS.ADDRESS',
  STATUS: 'CHANNELS.STATUS',
  ACTION: 'CHANNELS.ACTION',
  ACTION_SUCCESS: 'CHANNELS.ACTION_SUCCESS',
  ACTION_FAILED: 'CHANNELS.ACTION_FAILED',
  MORE_OPTIONS: 'CHANNELS.MORE_OPTIONS',
  NO_UNITS_FOUND: 'CHANNELS.NO_UNITS_FOUND',
  NO_UNITS_SEARCH_RESULT: 'CHANNELS.NO_UNITS_SEARCH_RESULT',
  NO_UNITS_IMPORTED: 'CHANNELS.NO_UNITS_IMPORTED',
  INCOMPLETE_CONNECTION: 'CHANNELS.INCOMPLETE_CONNECTION',
  INCOMPLETE_CONNECTION_DESC: 'CHANNELS.INCOMPLETE_CONNECTION_DESC',
  RECONNECT_ACCOUNT: 'CHANNELS.RECONNECT_ACCOUNT',
  ADD_NEW_PROPERTY: 'CHANNELS.ADD_NEW_PROPERTY',
  
  // Settings Modal
  ACCOUNT_SETTINGS: 'CHANNELS.ACCOUNT_SETTINGS',
  ACCOUNT_NAME: 'CHANNELS.ACCOUNT_NAME',
  ACCOUNT_ID_HOST_ID: 'CHANNELS.ACCOUNT_ID_HOST_ID',
  CONNECTION_STATUS: 'CHANNELS.CONNECTION_STATUS',
  LAST_SYNC: 'CHANNELS.LAST_SYNC',
  DISCONNECT: 'CHANNELS.DISCONNECT',
  NOT_AVAILABLE: 'CHANNELS.NOT_AVAILABLE',
  
  // Disconnect Modal
  DISCONNECT_CONFIRM_TITLE: 'CHANNELS.DISCONNECT_CONFIRM_TITLE',
  DISCONNECT_CONFIRM_DESC1: 'CHANNELS.DISCONNECT_CONFIRM_DESC1',
  DISCONNECT_CONFIRM_DESC2: 'CHANNELS.DISCONNECT_CONFIRM_DESC2',
  DISCONNECT_SUCCESS: 'CHANNELS.DISCONNECT_SUCCESS',
  DISCONNECT_ERROR: 'CHANNELS.DISCONNECT_ERROR',
  RESYNC_SUCCESS: 'CHANNELS.RESYNC_SUCCESS',
  RESYNC_ERROR: 'CHANNELS.RESYNC_ERROR',
  RECONNECTING: 'CHANNELS.RECONNECTING',
  DISCONNECTED_ACCOUNT_ALERT: 'CHANNELS.DISCONNECTED_ACCOUNT_ALERT',
  UNDO: 'CHANNELS.UNDO',
  CONTACT_SUPPORT: 'CHANNELS.CONTACT_SUPPORT',
  
  // All Units Synced Modal
  ALL_UNITS_SYNCED_TITLE: 'CHANNELS.ALL_UNITS_SYNCED_TITLE',
  ALL_UNITS_SYNCED_DESC: 'CHANNELS.ALL_UNITS_SYNCED_DESC',
  CLOSE: 'CHANNELS.CLOSE',
  
  // Import Units Page
  IMPORT_UNITS_TITLE: 'CHANNELS.IMPORT_UNITS_TITLE',
  IMPORT_UNITS_DESCRIPTION: 'CHANNELS.IMPORT_UNITS_DESCRIPTION',
  INVALID_INTEGRATION: 'CHANNELS.INVALID_INTEGRATION',
  INVALID_INTEGRATION_DESC: 'CHANNELS.INVALID_INTEGRATION_DESC',
  MISSING_CHANNEL_ID: 'CHANNELS.MISSING_CHANNEL_ID',
  MISSING_CHANNEL_ID_DESC: 'CHANNELS.MISSING_CHANNEL_ID_DESC',
  BACK_TO_CHANNELS: 'CHANNELS.BACK_TO_CHANNELS',
  ERROR_LOADING_UNITS: 'CHANNELS.ERROR_LOADING_UNITS',
  ERROR_LOADING_UNITS_DESC: 'CHANNELS.ERROR_LOADING_UNITS_DESC',
  TRY_AGAIN: 'CHANNELS.TRY_AGAIN',
  CHANNEL_DATA_NOT_AVAILABLE: 'CHANNELS.CHANNEL_DATA_NOT_AVAILABLE',
  
  // Booking Unit Type Step
  BOOKING_UNIT_TYPE_TITLE: 'CHANNELS.BOOKING_UNIT_TYPE_TITLE',
  BOOKING_UNIT_TYPE_DESC: 'CHANNELS.BOOKING_UNIT_TYPE_DESC',
  MULTIPLE_SEPARATE_UNITS: 'CHANNELS.MULTIPLE_SEPARATE_UNITS',
  MULTIPLE_SEPARATE_UNITS_DESC: 'CHANNELS.MULTIPLE_SEPARATE_UNITS_DESC',
  SINGLE_MULTI_UNIT_PROPERTY: 'CHANNELS.SINGLE_MULTI_UNIT_PROPERTY',
  SINGLE_MULTI_UNIT_PROPERTY_DESC: 'CHANNELS.SINGLE_MULTI_UNIT_PROPERTY_DESC',
  
  // Booking Property ID Step
  ENTER_PROPERTY_IDS: 'CHANNELS.ENTER_PROPERTY_IDS',
  ENTER_PROPERTY_IDS_DESC: 'CHANNELS.ENTER_PROPERTY_IDS_DESC',
  ENTER_PROPERTY_ID: 'CHANNELS.ENTER_PROPERTY_ID',
  ENTER_PROPERTY_ID_DESC: 'CHANNELS.ENTER_PROPERTY_ID_DESC',
  PROPERTY_ID_LABEL: 'CHANNELS.PROPERTY_ID_LABEL',
  PROPERTY_ID_PLACEHOLDER: 'CHANNELS.PROPERTY_ID_PLACEHOLDER',
  ADD_ANOTHER_PROPERTY_ID: 'CHANNELS.ADD_ANOTHER_PROPERTY_ID',
  VERIFY_CONNECTION: 'CHANNELS.VERIFY_CONNECTION',
  VERIFY_CONNECTION_AGAIN: 'CHANNELS.VERIFY_CONNECTION_AGAIN',
  OPEN_BOOKING_WEBSITE: 'CHANNELS.OPEN_BOOKING_WEBSITE',
  INVALID_ID_ERROR: 'CHANNELS.INVALID_ID_ERROR',
  
  // Gathern Phone Step
  GATHERN_LOGIN_TITLE: 'CHANNELS.GATHERN_LOGIN_TITLE',
  GATHERN_LOGIN_DESC: 'CHANNELS.GATHERN_LOGIN_DESC',
  PHONE_NUMBER: 'CHANNELS.PHONE_NUMBER',
  ENTER_PHONE_NUMBER: 'CHANNELS.ENTER_PHONE_NUMBER',
  CONTINUE: 'CHANNELS.CONTINUE',
  
  // Gathern OTP Step
  VERIFY_NUMBER_TITLE: 'CHANNELS.VERIFY_NUMBER_TITLE',
  VERIFY_NUMBER_DESC: 'CHANNELS.VERIFY_NUMBER_DESC',
  DIDNT_RECEIVE_CODE: 'CHANNELS.DIDNT_RECEIVE_CODE',
  RESEND_IN: 'CHANNELS.RESEND_IN',
  RESEND: 'CHANNELS.RESEND',
  
  // Properties List View
  UNITS_MANAGEMENT: 'CHANNELS.UNITS_MANAGEMENT',
  UNITS_MANAGEMENT_DESC: 'CHANNELS.UNITS_MANAGEMENT_DESC',
  ADD_UNITS: 'CHANNELS.ADD_UNITS',
  ADD_UNITS_DESC: 'CHANNELS.ADD_UNITS_DESC',
  NUMBER_OF_PROPERTIES: 'CHANNELS.NUMBER_OF_PROPERTIES',
  CONNECTED_PROPERTIES: 'CHANNELS.CONNECTED_PROPERTIES',
  NUMBER_OF_CHANNELS: 'CHANNELS.NUMBER_OF_CHANNELS',
  PROPERTIES_LIST: 'CHANNELS.PROPERTIES_LIST',
  SEARCH: 'CHANNELS.SEARCH',
  CHANNELS: 'CHANNELS.CHANNELS',
  RESULTS_PER_PAGE: 'CHANNELS.RESULTS_PER_PAGE',
  NO_PROPERTIES_YET: 'CHANNELS.NO_PROPERTIES_YET',
  MANAGE_MAPPING: 'CHANNELS.MANAGE_MAPPING',
  
  // Units Mapping View
  AIRBNB_UNITS: 'CHANNELS.AIRBNB_UNITS',
  BOOKING_UNITS: 'CHANNELS.BOOKING_UNITS',
  GATHERN_UNITS: 'CHANNELS.GATHERN_UNITS',
  SUCCESS_MERGED: 'CHANNELS.SUCCESS_MERGED',
  ERROR_MERGE_FAILED: 'CHANNELS.ERROR_MERGE_FAILED',
  SUCCESS_UNMAPPED: 'CHANNELS.SUCCESS_UNMAPPED',
  ERROR_UNMAP_FAILED: 'CHANNELS.ERROR_UNMAP_FAILED',
  
  // Error State
  ERROR_OCCURRED: 'CHANNELS.ERROR_OCCURRED',
  RETRY: 'CHANNELS.RETRY',
  
  // Shared
  LOADING: 'CHANNELS.LOADING',
  CONFIRM: 'CHANNELS.CONFIRM',
  YES: 'CHANNELS.YES',
  NO: 'CHANNELS.NO',
  
  // Booking Accounts Step
  BOOKING_ACCOUNTS: 'CHANNELS.BOOKING_ACCOUNTS',
  BOOKING_ACCOUNTS_DESC: 'CHANNELS.BOOKING_ACCOUNTS_DESC',
  ADD_NEW_BOOKING_ACCOUNT: 'CHANNELS.ADD_NEW_BOOKING_ACCOUNT',
  BOOKING_ACCOUNT_NUMBER: 'CHANNELS.BOOKING_ACCOUNT_NUMBER',
  PROPERTY_LABEL: 'CHANNELS.PROPERTY_LABEL',
  UNIT_LABEL: 'CHANNELS.UNIT_LABEL',
  VIEW_PROPERTIES: 'CHANNELS.VIEW_PROPERTIES',
  
  // Booking Account Section
  LAST_SYNC_AGO: 'CHANNELS.LAST_SYNC_AGO',
  ADD_NEW_PROPERTY_BUTTON: 'CHANNELS.ADD_NEW_PROPERTY_BUTTON',
  IMPORT_NEW_UNITS_BUTTON: 'CHANNELS.IMPORT_NEW_UNITS_BUTTON',
  REFRESH_SYNC_BUTTON: 'CHANNELS.REFRESH_SYNC_BUTTON',
  
  // Add Booking Property Modal
  ADD_NEW_PROPERTY_TITLE: 'CHANNELS.ADD_NEW_PROPERTY_TITLE',
  IMPORT_UNITS_MODAL_TITLE: 'CHANNELS.IMPORT_UNITS_MODAL_TITLE',
  
  // Tutorial Modal
  TUTORIAL_PREVIOUS: 'CHANNELS.TUTORIAL_PREVIOUS',
  TUTORIAL_NEXT: 'CHANNELS.TUTORIAL_NEXT',
  TUTORIAL_START_CONNECTION: 'CHANNELS.TUTORIAL_START_CONNECTION',
  
  // Importing Modal
  IMPORTING_MODAL_TITLE: 'CHANNELS.IMPORTING_MODAL_TITLE',
  IMPORTING_MODAL_DESC: 'CHANNELS.IMPORTING_MODAL_DESC',
  IMPORTING_MODAL_NOTIFICATION: 'CHANNELS.IMPORTING_MODAL_NOTIFICATION',
  
  // Units Mapping - Additional Keys
  UNITS_MAPPING_TITLE: 'CHANNELS.UNITS_MAPPING.TITLE',
  UNITS_MAPPING_DESC: 'CHANNELS.UNITS_MAPPING.DESCRIPTION',
  UNITS_MAPPING_BACK: 'CHANNELS.UNITS_MAPPING.BACK_TO_CHANNELS',
  UNITS_MAPPING_SELECTED: 'CHANNELS.UNITS_MAPPING.SELECTED',
  UNITS_MAPPING_NO_UNITS: 'CHANNELS.UNITS_MAPPING.NO_UNITS',
  UNITS_MAPPING_PROPERTY: 'CHANNELS.UNITS_MAPPING.PROPERTY',
  UNITS_MAPPING_SEARCH: 'CHANNELS.UNITS_MAPPING.SEARCH_PLACEHOLDER',
  UNITS_MAPPING_FILTER_ALL: 'CHANNELS.UNITS_MAPPING.FILTER_ALL',
  UNITS_MAPPING_FILTER_MAPPED: 'CHANNELS.UNITS_MAPPING.FILTER_MAPPED',
  UNITS_MAPPING_FILTER_NOT_MAPPED: 'CHANNELS.UNITS_MAPPING.FILTER_NOT_MAPPED',
  UNITS_MAPPING_SELECTED_ITEMS: 'CHANNELS.UNITS_MAPPING.SELECTED_ITEMS',
  UNITS_MAPPING_CANCEL: 'CHANNELS.UNITS_MAPPING.CANCEL',
  UNITS_MAPPING_CONFIRM_MERGE: 'CHANNELS.UNITS_MAPPING.CONFIRM_MERGE',
  UNITS_MAPPING_EMPTY_TITLE: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_TITLE',
  UNITS_MAPPING_EMPTY_DESC: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_DESCRIPTION',
  UNITS_MAPPING_EMPTY_HELPER: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_HELPER',
  UNITS_MAPPING_START: 'CHANNELS.UNITS_MAPPING.START_MAPPING',
  UNITS_MAPPING_MSOOL_UNITS: 'CHANNELS.UNITS_MAPPING.MSOOL_UNITS_TITLE',
  UNITS_MAPPING_UNIT: 'CHANNELS.UNITS_MAPPING.UNIT',
  UNITS_MAPPING_CHANNELS: 'CHANNELS.UNITS_MAPPING.CHANNELS',
  UNITS_MAPPING_ACTIONS: 'CHANNELS.UNITS_MAPPING.ACTIONS',
  UNITS_MAPPING_UNMAP: 'CHANNELS.UNITS_MAPPING.UNMAP',
  UNITS_MAPPING_NO_MAPPED: 'CHANNELS.UNITS_MAPPING.NO_MAPPED_UNITS',
  UNITS_MAPPING_MODAL_TITLE: 'CHANNELS.UNITS_MAPPING.MODAL_TITLE',
  UNITS_MAPPING_MODAL_DESC: 'CHANNELS.UNITS_MAPPING.MODAL_DESCRIPTION',
  UNITS_MAPPING_WHEN_TO_USE: 'CHANNELS.UNITS_MAPPING.MODAL_WHEN_TO_USE_TITLE',
  UNITS_MAPPING_WHEN_1: 'CHANNELS.UNITS_MAPPING.MODAL_WHEN_TO_USE_1',
  UNITS_MAPPING_WHEN_2: 'CHANNELS.UNITS_MAPPING.MODAL_WHEN_TO_USE_2',
  UNITS_MAPPING_WHEN_3: 'CHANNELS.UNITS_MAPPING.MODAL_WHEN_TO_USE_3',
  UNITS_MAPPING_INFO: 'CHANNELS.UNITS_MAPPING.MODAL_INFO_TEXT',
  UNITS_MAPPING_START_NOW: 'CHANNELS.UNITS_MAPPING.MODAL_START_BUTTON',
  UNITS_MAPPING_MERGE_TITLE: 'CHANNELS.UNITS_MAPPING.MERGE_CONFIRM_TITLE',
  UNITS_MAPPING_MERGE_MSG: 'CHANNELS.UNITS_MAPPING.MERGE_CONFIRM_MESSAGE',
  UNITS_MAPPING_MERGE_NO: 'CHANNELS.UNITS_MAPPING.MERGE_CONFIRM_NO',
  UNITS_MAPPING_MERGE_YES: 'CHANNELS.UNITS_MAPPING.MERGE_CONFIRM_YES',
  UNITS_MAPPING_STATUS_MAPPED: 'CHANNELS.UNITS_MAPPING.STATUS_MAPPED',
  UNITS_MAPPING_STATUS_NOT_MAPPED: 'CHANNELS.UNITS_MAPPING.STATUS_NOT_MAPPED',
  
  // All Units Synced Modal
  NO_NEW_UNITS_TITLE: 'CHANNELS.NO_NEW_UNITS_TITLE',
  NO_NEW_UNITS_DESC: 'CHANNELS.NO_NEW_UNITS_DESC',
  OK: 'CHANNELS.OK',
  
  // Import Progress
  IMPORT_COMPLETED: 'CHANNELS.IMPORT_COMPLETED',
  IMPORT_FAILED: 'CHANNELS.IMPORT_FAILED',
  IMPORT_COMPLETED_DESC: 'CHANNELS.IMPORT_COMPLETED_DESC',
  IMPORT_ERROR: 'CHANNELS.IMPORT_ERROR',
  
  // Table Selection
  SELECT: 'CHANNELS.SELECT',
  
  // Connect Step
  CONNECT_CHANNEL_WITH_MSOOL: 'CHANNELS.CONNECT_CHANNEL_WITH_MSOOL',
  
  // View All Accounts
  VIEW_ALL_ACCOUNTS: 'CHANNELS.VIEW_ALL_ACCOUNTS',
  
  // Account Settings Modal
  ACCOUNT_DISPLAY_NAME: 'CHANNELS.ACCOUNT_DISPLAY_NAME',
  ACCOUNT_NOT_FOUND: 'CHANNELS.ACCOUNT_NOT_FOUND',
  
  // Tutorial Steps - Airbnb
  TUTORIAL_AIRBNB_STEP1_TITLE: 'CHANNELS.TUTORIAL.AIRBNB.STEP1_TITLE',
  TUTORIAL_AIRBNB_STEP1_DESC: 'CHANNELS.TUTORIAL.AIRBNB.STEP1_DESC',
  TUTORIAL_AIRBNB_STEP2_TITLE: 'CHANNELS.TUTORIAL.AIRBNB.STEP2_TITLE',
  TUTORIAL_AIRBNB_STEP2_DESC: 'CHANNELS.TUTORIAL.AIRBNB.STEP2_DESC',
  TUTORIAL_AIRBNB_STEP3_TITLE: 'CHANNELS.TUTORIAL.AIRBNB.STEP3_TITLE',
  TUTORIAL_AIRBNB_STEP3_DESC: 'CHANNELS.TUTORIAL.AIRBNB.STEP3_DESC',
  
  // Tutorial Steps - Gathern
  TUTORIAL_GATHERN_STEP1_TITLE: 'CHANNELS.TUTORIAL.GATHERN.STEP1_TITLE',
  TUTORIAL_GATHERN_STEP1_DESC: 'CHANNELS.TUTORIAL.GATHERN.STEP1_DESC',
  TUTORIAL_GATHERN_STEP2_TITLE: 'CHANNELS.TUTORIAL.GATHERN.STEP2_TITLE',
  TUTORIAL_GATHERN_STEP2_DESC: 'CHANNELS.TUTORIAL.GATHERN.STEP2_DESC',
  TUTORIAL_GATHERN_STEP3_TITLE: 'CHANNELS.TUTORIAL.GATHERN.STEP3_TITLE',
  TUTORIAL_GATHERN_STEP3_DESC: 'CHANNELS.TUTORIAL.GATHERN.STEP3_DESC',
  
  // Tutorial Steps - Booking
  TUTORIAL_BOOKING_STEP1_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP1_TITLE',
  TUTORIAL_BOOKING_STEP1_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP1_DESC',
  TUTORIAL_BOOKING_STEP2_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP2_TITLE',
  TUTORIAL_BOOKING_STEP2_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP2_DESC',
  TUTORIAL_BOOKING_STEP3_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP3_TITLE',
  TUTORIAL_BOOKING_STEP3_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP3_DESC',
  TUTORIAL_BOOKING_STEP4_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP4_TITLE',
  TUTORIAL_BOOKING_STEP4_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP4_DESC',
  TUTORIAL_BOOKING_STEP5_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP5_TITLE',
  TUTORIAL_BOOKING_STEP5_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP5_DESC',
  TUTORIAL_BOOKING_STEP6_TITLE: 'CHANNELS.TUTORIAL.BOOKING.STEP6_TITLE',
  TUTORIAL_BOOKING_STEP6_DESC: 'CHANNELS.TUTORIAL.BOOKING.STEP6_DESC',
  
  // Additional Units Mapping keys
  UNITS_MAPPING_AIRBNB_UNITS: 'CHANNELS.UNITS_MAPPING.AIRBNB_UNITS',
  UNITS_MAPPING_BOOKING_UNITS: 'CHANNELS.UNITS_MAPPING.BOOKING_UNITS',
  UNITS_MAPPING_GATHERN_UNITS: 'CHANNELS.UNITS_MAPPING.GATHERN_UNITS',
  UNITS_MAPPING_SUCCESS_MERGED: 'CHANNELS.UNITS_MAPPING.SUCCESS_MERGED',
  UNITS_MAPPING_ERROR_MERGE_FAILED: 'CHANNELS.UNITS_MAPPING.ERROR_MERGE_FAILED',
  UNITS_MAPPING_SUCCESS_UNMAPPED: 'CHANNELS.UNITS_MAPPING.SUCCESS_UNMAPPED',
  UNITS_MAPPING_ERROR_UNMAP_FAILED: 'CHANNELS.UNITS_MAPPING.ERROR_UNMAP_FAILED',
  UNITS_MAPPING_UNMAP_CONFIRM_TITLE: 'CHANNELS.UNITS_MAPPING.UNMAP_CONFIRM_TITLE',
  UNITS_MAPPING_UNMAP_CONFIRM_MESSAGE: 'CHANNELS.UNITS_MAPPING.UNMAP_CONFIRM_MESSAGE',
  UNITS_MAPPING_UNMAP_CONFIRM_YES: 'CHANNELS.UNITS_MAPPING.UNMAP_CONFIRM_YES',
  UNITS_MAPPING_UNMAP_CONFIRM_NO: 'CHANNELS.UNITS_MAPPING.UNMAP_CONFIRM_NO',
  UNITS_MAPPING_EMPTY_STATE_TITLE: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_TITLE',
  UNITS_MAPPING_EMPTY_STATE_DESCRIPTION: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_DESCRIPTION',
  UNITS_MAPPING_EMPTY_STATE_HELPER: 'CHANNELS.UNITS_MAPPING.EMPTY_STATE_HELPER',
  UNITS_MAPPING_START_MAPPING: 'CHANNELS.UNITS_MAPPING.START_MAPPING',
  UNITS_MAPPING_MSOOL_UNITS_TITLE: 'CHANNELS.UNITS_MAPPING.MSOOL_UNITS_TITLE',
  
  // Common keys
  COMMON_LOADING: 'COMMON.LOADING',
  COMMON_CONFIRM: 'COMMON.CONFIRM',
  COMMON_CANCEL: 'COMMON.CANCEL',
  
  // Modal keys
  NOTIFICATION_ON_COMPLETE: 'CHANNELS.NOTIFICATION_ON_COMPLETE',
  
  // Refresh Sync Modal
  REFRESH_SYNC_MODAL_TITLE: 'CHANNELS.REFRESH_SYNC_MODAL.TITLE',
  REFRESH_SYNC_MODAL_DESCRIPTION: 'CHANNELS.REFRESH_SYNC_MODAL.DESCRIPTION',
  REFRESH_SYNC_MODAL_CONFIRM: 'CHANNELS.REFRESH_SYNC_MODAL.CONFIRM',
  REFRESH_SYNC_MODAL_CANCEL: 'CHANNELS.REFRESH_SYNC_MODAL.CANCEL',
};
